// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1NYxt","savePackageButton":"ClientWallet_savePackageButton__13d8u"};